/**
 * Typed event notifier — replaces untyped DOM CustomEvents.
 *
 * Usage:
 *   const notifier = new EventNotifier<[message?: string]>();
 *   const unsubscribe = notifier.subscribe((msg) => logger.debug(msg));
 *   notifier.notify('hello');
 *   unsubscribe();
 *
 *   const simple = new EventNotifier();       // no payload
 *   simple.subscribe(() => doStuff());
 *   simple.notify();
 */
export class EventNotifier<T extends unknown[] = []> {
	private listeners = new Set<(...args: T) => void>();

	subscribe(listener: (...args: T) => void): () => void {
		this.listeners.add(listener);
		return () => {
			this.listeners.delete(listener);
		};
	}

	notify(...args: T): void {
		for (const listener of this.listeners) {
			listener(...args);
		}
	}
}
